<template>
  <analytics-chart-wrapper
    :title="title"
    chart-class="campaignsChart"
    :chart="chart"
    :settings="settings"
    :options="options"
    :items="items"
    :export-table-method="exportTableMethod"
  >
    <slot></slot>
  </analytics-chart-wrapper>
</template>

<script>
import CampaignsChart from '@/jquery/analytics/charts/campaignsChart'
import CampaignVariantsChart from '@/jquery/analytics/charts/campaignVariantsChart'
import CampaignWorkflowVariantsChart from '@/jquery/analytics/charts/campaignWorkflowVariantsChart'
import AnalyticsChartWrapper from '@/common/components/charts/AnalyticsChartWrapper'
import chartsMixin from '@/common/mixins/chartsMixin'
import { mapState } from 'vuex'
export default {
  name: 'CampaignsChart',
  mixins: [chartsMixin],
  components: { AnalyticsChartWrapper },
  props: {
    items: {
      type: Object,
      default: null
    },
    channel: {
      type: String
    },
    isCampaignVariant: {
      type: Boolean,
      required: false,
      default: false
    },
    exportTableMethod: {
      type: String,
      default: null
    },
    isWorkflowCampaign: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    ...mapState({
      companyChannels: state => state.app.company_channels
    }),
    project() {
      return this.$store.state.app.features
    },
    title() {
      if (this.isCampaignVariant) {
        return this.$t('Analytics_CampaignsVariantsChart_Title')
      } else {
        return this.$t('Analytics_CampaignsChart_Title')
      }
    },
    options() {
      return {
        campaign_id: this.$route.query.id
      }
    },
    chartSettings() {
      switch (this.channel) {
        case 'web_push':
          return {
            show_web_push: this.companyChannels.web_push,
            modifier: 'web_push_sent'
          }
        case 'mobile_push':
          return {
            show_mobile_push:
              this.companyChannels.android_push ||
              this.companyChannels.ios_push,
            modifier: 'mobile_push_sent'
          }
        case 'inapp':
          return {
            show_inapp: this.companyChannels.inapp,
            modifier: 'inapp_sent'
          }
        case 'onsite':
          return {
            show_inweb: this.companyChannels.onsite,
            modifier: 'inweb_sent'
          }
        case 'email':
          return {
            show_email: this.companyChannels.email,
            modifier: 'email_sent'
          }
        case 'sms':
          return {
            show_sms: this.companyChannels.sms,
            modifier: 'sms_sent'
          }
        case 'inbox':
          return {
            show_inbox: this.companyChannels.inbox,
            show_inbox_open_stats: this.project.showInboxOpenStats,
            modifier: 'inbox_sent'
          }
        default:
          return {
            show_web_push: this.companyChannels.web_push,
            show_mobile_push:
              this.companyChannels.android_push ||
              this.companyChannels.ios_push,
            show_inapp: this.companyChannels.inapp,
            show_inbox: this.companyChannels.inbox,
            show_inbox_open_stats: this.project.showInboxOpenStats,
            show_email: this.companyChannels.email,
            show_sms: this.companyChannels.sms,
            show_facebook: this.companyChannels.facebook,
            show_whatsapp: this.companyChannels.whatsapp,
            show_inweb: this.companyChannels.onsite,
            show_conversions: true,
            modifier: '',
            new_goal_conversions: this.project.enableNewGoalConversion
          }
      }
    }
  },

  methods: {
    chart() {
      this.chartSettings.element = $('.chart-wrapper.campaignsChart')
      this.chartSettings.mode = 'timeline'

      if (this.isCampaignVariant) {
        if (this.isWorkflowCampaign) {
          return new CampaignWorkflowVariantsChart(this.chartSettings)
        }
        return new CampaignVariantsChart(this.chartSettings)
      }

      return new CampaignsChart(this.chartSettings)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/analytics/components/CampaignsChart.vue